import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageDropzone from '../../components/ImageDropzone';
import { MultiSelect } from 'primereact/multiselect';
import GoogleMap from "../../components/GoogleMap";
import { Chips } from 'primereact/chips';
        
const InterviewForm = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);

  const [users, setUsers] = useState([]);
  const [address, setAddress] = useState([]);
  const [files, setFiles] = useState(null);
  
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    members: [],
    user_id: '',
    tags: '',
    date: '',
    start_time: '',
    end_time: '',
    old_images: [],

  });

  const [location, setLocation] = useState({
    text: '',
    lat: '',
    lng: '',
  });

  useEffect(() => {
    if (id) {
      getSingleData();
    }
    getUsers();
  }, [id]);

  
  useEffect(() => {
    if (formData.user_id) {
      getUserAddress();
    }
  }, [formData.user_id]);

  const updateOldImages = (newOldImages) => {
    setFormData({ ...formData, old_images: newOldImages });
  };

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `events/${id}`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setFormData(data.data);
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const locationChanged = (newLocation) => {
    setLocation(newLocation);
  };

  const getUsers = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `users/list`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setUsers(data.data);
        setFormData({ ...formData, user_id: data.admin_user_id });
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

   const getUserAddress = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `user-address/`+formData.user_id, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setAddress(data.data);
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
      if (files && Array.isArray(files) && files.length > 0) {
        files.forEach((file) => {
           data.append("images[]", file); 
        });
      }
      
      data.append("location", location.text);  
      data.append("lat", location.lat);  
      data.append("lng", location.lng);  



      const response = await ApiService.request({
        method: 'POST',
        url: `events/createOrUpdate/${id || ''}`, // Replace with your API endpoint
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/events');
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Event
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/events" className="text-muted text-hover-primary">Events</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-12 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Event Title"
                      required
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  
                  
                  {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Members</label>
                    <MultiSelect 
                        multiple
                       value={formData.members}
                       options={users}
                       optionLabel="name" 
                       optionValue="id" 
                       maxSelectedLabels={5}
                      onChange={(selectedOption) =>
                        setFormData({ ...formData, members: selectedOption.value })
                      }
                      placeholder="Select Members"
                      filter
                      checkmark={true}
                    />
                  </div> */}
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Date</label>
                    <input
                      type="date"
                      className="form-control form-control-solid"
                      placeholder="Enter Event date"
                      required
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Start Time</label>
                    <input
                      type="time"
                      className="form-control form-control-solid"
                      placeholder="Enter Event start time"
                      required
                      name="start_time"
                      value={formData.start_time}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> End Time</label>
                    <input
                      type="time"
                      className="form-control form-control-solid"
                      placeholder="Enter Event end time"
                      required
                      name="end_time"
                      value={formData.end_time}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2"> Tags</label>
                    <Chips value={formData.tags} name="tags" 
                    className="form-control form-control-solid"
                    placeholder="Write Tag and Press enter" onChange={handleChange} separator="," />
        
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2"> Description</label>
                    <textarea 
                      name="description" rows={3}
                      className="form-control form-control-solid"
                      placeholder="Enter Event description"
                      value={formData.description}
                      onChange={handleChange}>
                    </textarea>
                    
                  </div>

                  {/* Images */}
                  <div className="col-md-12 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-3">
                      <span>Event Images</span>
                    </label>
                    <ImageDropzone
                      title="images"
                      oldImages={formData.old_images}
                      updateOldImages={updateOldImages}
                      setFiles={setFiles}
                    />
                  </div>

                  {!isLoader && 
                      <div className="col-md-12">
                        <GoogleMap onLocationChanged={locationChanged} locationNew={location} />
                      </div>
                  }


                </div>


                  
                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to={`/events`} className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : 'Submit'}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewForm;
